export default {
    baiRiLuckDrawNum:
        "/gateway/huilianOperation/hoBaiRiActivitycs/baiRiLuckDrawNum", // 用户剩余当日可抽奖次数
    baiRiActivityUserPrizeList:
        "/gateway/huilianOperation/hoBaiRiActivitycs/baiRiActivityUserPrizeList", // 用户中奖记录
    baiRiActivityLastUserPrizeList:
        "/gateway/huilianOperation/hoBaiRiActivitycs/baiRiActivityLastUserPrizeList", // 用户最近中奖记录
    baiRiLuckDraw: "/gateway/huilianOperation/hoBaiRiActivitycs/baiRiLuckDraw", // 百日行动点击抽奖
    selectBaiRiActivityDetail:
        "/gateway/huilianOperation/hoBaiRiActivitycs/selectBaiRiActivityDetail", // 查看活动详情
};



// WEBPACK FOOTER //
// ./src/hundredDaysActivities/api.js